import Vue from 'vue';
import { platform, version } from '@/common/bridge';
import * as Types from '@/common/types';
import * as PleasedModel from '@/common/api/models.pleased';
import { ConnectToAgent, ArticleInteractionExternEvent } from './bot/types';

export const EventBus = new Vue();

export let isArticleOpen = false;
export let isMyRequestOpen = false;
export let isArticleAutocompleteFocused = false;

// OpenArticle
export const emitOpenArticle = (data: Types.ArticlePageControl) => {
  isArticleOpen = data.isOpen;
  EventBus.$emit('OpenArticle', { ...data });
};

export const onOpenArticle = (callback: (data: Types.ArticlePageControl) => void) => {
  EventBus.$on('OpenArticle', callback);
};

// MyRequest: true, false
export const emitOpenMyRequest = (isOpen: boolean) => {
  isArticleOpen = isOpen;
  EventBus.$emit('OpenMyRequest', isOpen);
};

export const onOpenMyRequest = (callback: (isOpen: boolean) => void) => {
  EventBus.$on('OpenMyRequest', callback);
};

export const emitFloatButton = (isOpen: boolean) => {
  if (!version || (platform === 'app' || platform === 'ios')) {
    emitAppFloatButton(isOpen);
    return;
  };
  EventBus.$emit('OpenFloatButton', isOpen);
};

export const onFloatButton = (callback: (isOpen: boolean) => void) => {
  EventBus.$on('OpenFloatButton', callback);
};

export const emitAppFloatButton = (isOpen: boolean) => {
  EventBus.$emit('OpenAppFloatButton', isOpen);
};

export const onAppFloatButton = (callback: (isOpen: boolean) => void) => {
  EventBus.$on('OpenAppFloatButton', callback);
};

export const onArticleAutocompleteFocused = (callback: (isFocused: boolean) => void) => {
  EventBus.$on('ArticleAutocompleteFocused', callback);
  return () => EventBus.$off('ArticleAutocompleteFocused', callback);
};

export const emitArticleAutocompleteFocused = (isFocused: boolean) => {
  isArticleAutocompleteFocused = isFocused;
  EventBus.$emit('ArticleAutocompleteFocused', isFocused);
};

export const onArticleConnectToAgentRequest = (callback: (data: { articleDetail: PleasedModel.ArticleDetail, connectConfig: ConnectToAgent }) => void) => {
  EventBus.$on('ArticleConnectToAgentRequest', callback);
  return () => EventBus.$off('ArticleConnectToAgentRequest', callback);
};

export const emitArticleConnectToAgentRequest = (data: { articleDetail: PleasedModel.ArticleDetail, connectConfig: ConnectToAgent }) => {
  EventBus.$emit('ArticleConnectToAgentRequest', data);
};

export const onArticleAutocompleteCollapse = (callback: (isCollapsed: boolean) => void) => {
  EventBus.$on('ArticleAutocompleteCollapse', callback);
  return () => EventBus.$off('ArticleAutocompleteCollapse', callback);
};

export const emitArticleAutocompleteCollapse = (isCollapsed: boolean) => {
  EventBus.$emit('ArticleAutocompleteCollapse', isCollapsed);
};

export const ArticleInteractionBus = createPubSubBus<ArticleInteractionExternEvent>('PL_ARTICLE_INTERACTION');
export const ReloadActiveConversationBus = createPubSubBus<void>('PL_RELOAD_ACTIVE_CONVERSATION');

function createPubSubBus<T> (name: string) {
  return {
    pub (data: T) {
      EventBus.$emit(name, data);
    },
    sub (listener: (data: T) => void) {
      EventBus.$on(name, listener);
      return () => { EventBus.$off(name, listener); };
    },
  };
}
